import React from "react";
import {
  BaseEdge,
  EdgeLabelRenderer,
  // getBezierPath,
  // useReactFlow,
  getSmoothStepPath
} from "@xyflow/react";
import "./buttonedge.css";

export const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  label,
  labelStyle,
}) => {
  const labelStylex = label
    ? {
        fontSize: labelStyle.fontSize,
        fontWeight: labelStyle.fontWeight,
        color: labelStyle.fill,
        backgroundColor: labelStyle.backgroundColor[label],
        borderRadius: labelStyle.borderRadius,
        paddingTop: labelStyle.paddingV,
        paddingBottom: labelStyle.paddingV,
        paddingLeft: labelStyle.paddingH,
        paddingRight: labelStyle.paddingH,
      }
    : { display: "none" };

  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  //   console.log(path); //=> "M0 20L20 20L 70,20Q 75,20 75,25L 75,95Q ..."
  //   console.log(labelX2, labelY2); //=> 75, 60
  //   console.log(offsetX, offsetY); //=> 75, 40

  // const onEdgeClick = () => {
  //   setEdges((edges) => edges.filter((edge) => edge.id !== id));
  // };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            // everything inside EdgeLabelRenderer has no pointer events by default
            // if you have an interactive element, set pointer-events: all
            pointerEvents: "all",
          }}
          //   className="nodrag nopan"
        >
          <div style={labelStylex}>{label}</div>
        </div>
      </EdgeLabelRenderer>
    </>
  );
};
